import {
  Box,
  Text,
  Badge,
  Avatar,
} from '@mantine/core';
import {
  IconClipboardList,
  IconChevronRight,
} from '@tabler/icons-react';
import type { AssetAuditEvent } from '@/types/models';

interface AuditMobileCardProps {
  audit: AssetAuditEvent;
  onView: (audit: AssetAuditEvent) => void;
}

const statusColors: Record<string, string> = {
  draft: 'gray',
  in_progress: 'blue',
  completed: 'green',
  cancelled: 'red',
};

export function AuditMobileCard({ audit, onView }: AuditMobileCardProps) {
  return (
    <Box
      onClick={() => onView(audit)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px 16px',
        borderBottom: '1px solid var(--mantine-color-gray-2)',
        cursor: 'pointer',
        backgroundColor: 'white',
      }}
    >
      {/* Icon */}
      <Avatar color="blue" size={48} radius="sm" style={{ flexShrink: 0 }}>
        <IconClipboardList size={24} />
      </Avatar>

      {/* Content */}
      <Box style={{ flex: 1, minWidth: 0 }}>
        <Text fw={500} size="sm" truncate>
          {audit.name}
        </Text>
        <Text size="xs" c="dimmed">
          {audit.audit_date
            ? new Date(audit.audit_date).toLocaleDateString()
            : 'No date set'}
          {audit.due_by_date && (
            <> &bull; Due {new Date(audit.due_by_date).toLocaleDateString()}</>
          )}
        </Text>
      </Box>

      {/* Status badge */}
      <Badge
        color={statusColors[audit.status]}
        variant="light"
        size="sm"
        style={{ flexShrink: 0 }}
      >
        {audit.status.replace('_', ' ')}
      </Badge>

      {/* Chevron */}
      <IconChevronRight size={20} color="var(--mantine-color-gray-5)" style={{ flexShrink: 0 }} />
    </Box>
  );
}
